/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import gql from "graphql-tag";

export const ListApiKeysQuery = gql`
  query KeysQuery {
    keys: listApiKeys {
      keyId
      orgId
      scopes
      created
    }
  }
`;

export const GetApiKeyQuery = gql`
  query GetApiKeyQuery($keyId: ID!) {
    key: getApiKey(keyId: $keyId) {
      keyId
      key
      orgId
      scopes
      created
    }
  }
`;

export const DestroyApiKeyMutation = gql`
  mutation($keyId: ID!) {
    status: destroyApiKey(keyId: $keyId)
  }
`;

export interface ApiKey {
  keyId: string;
  key?: string;
  orgId: string;
  scopes: Array<string>;
  created: number;
}
